import Image from 'next/image'

const TesterPromoSignUpCopy = () => (
  <div className='container-small'>
    <div className='pt-24 flex flex-col'>
      <header className='mb-10'>
        <h1 className='text-5xl font-bold'>
          Zadbaj o widoczność Twojej firmy w sieci
        </h1>
        <p className='text-3xl font-normal mt-8'>
          Załóż profil pracodawcy i docieraj ze swoją marką do specjalistów IT.
          Pokaż się z ludzkiej strony i mów językiem swoich pracowników -
          pomożemy Ci to zrobić.
        </p>
      </header>
      <div className='w-4/5 mx-auto md:mt-32'>
        <div className='brain'>
          <Image
            src='/brain.png'
            width={450}
            height={340}
            priority
            alt='Bulldogjob - big brain'
          />
        </div>
        <div className='relative -top-6'>
          <Image
            src='/shadow.png'
            width={450}
            height={150}
            alt='Shadow of a big brain lol'
          />
        </div>
      </div>
    </div>
  </div>
)

export default TesterPromoSignUpCopy
